import client from "./client";
import { withCartRequestDeadline } from "./cartRequestDeadline";
import {
  extractAffiliateAttributionFromItem,
  mergeAffiliateAttributionIntoMetadata,
  mergeAffiliateAttributionIntoPayload,
} from "../utils/affiliateAttribution";
import { withBookingIntent } from "../utils/bookingIntent";
export { buildCartBenefitsPayload } from "../utils/cartBenefitsContract";

export const fetchCart = (options) => withCartRequestDeadline((config) => client.get(`/portal/cart`, config), options);

export const upsertCartItem = (item) => {
  const attribution = extractAffiliateAttributionFromItem(item);
  const payload = mergeAffiliateAttributionIntoPayload(item, attribution);
  payload.metadata = mergeAffiliateAttributionIntoMetadata(item?.metadata, attribution);
  return withCartRequestDeadline((config) => client.post(`/portal/cart/items`, withBookingIntent(payload), config));
};

export const updateCartItem = (itemId, patch) => withCartRequestDeadline((config) => client.patch(`/portal/cart/items/${encodeURIComponent(itemId)}`, patch, config));

export const validateCartItemCoupon = (itemId, payload) =>
  client.post(`/portal/cart/items/${encodeURIComponent(itemId)}/coupon/validate`, payload);

export const fetchAvailableCartItemCoupons = (itemId, params = {}) => {
  const query = new URLSearchParams(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== ""),
  ).toString();
  return client.get(`/portal/cart/items/${encodeURIComponent(itemId)}/coupons${query ? `?${query}` : ""}`);
};

export const removeCartItem = (itemId) => withCartRequestDeadline((config) => client.delete(`/portal/cart/items/${encodeURIComponent(itemId)}`, config));

export const clearCart = () => withCartRequestDeadline((config) => client.delete(`/portal/cart`, config));

export const createCartPaymentOrder = (payload) => client.post(`/portal/cart/checkout/payment-order`, payload);

export const refreshCartQuotes = (payload, options) => withCartRequestDeadline((config) => client.post(`/portal/cart/checkout/refresh`, payload, config), options);

export const quoteCartBenefits = (payload, options) => {
  const attributed = mergeAffiliateAttributionIntoPayload(payload);
  // Coupon selection belongs to the current request, including an explicit removal.
  return withCartRequestDeadline((config) => client.post(
    `/portal/cart/benefits/quote`,
    { ...attributed, couponCode: payload?.couponCode },
    config,
  ), options);
};

export const confirmCartCheckout = (payload) => client.post(`/portal/cart/checkout/confirm`, payload);
export const fetchActiveCartCheckout = (options) => withCartRequestDeadline((config) => client.get(`/portal/cart/checkout/active`, config), options);
export const fetchCartCheckoutStatus = (referenceCode) =>
  client.get(`/portal/cart/checkout/${encodeURIComponent(referenceCode)}/status`);

export const fetchCartCheckoutSummary = (referenceCode) =>
  client.get(`/portal/cart/checkout/${encodeURIComponent(referenceCode)}/summary`);

export const fetchCartCheckoutReceiptStatus = (referenceCode) =>
  client.get(`/portal/cart/checkout/${encodeURIComponent(referenceCode)}/receipt`);

// Informational only: does not save selections or refresh quotes.
export const previewCartSavings = (payload, options) => withCartRequestDeadline((config) => client.post(`/portal/cart/benefits/preview`, payload, config), options);
